import { DateTime } from 'luxon';

export const RelativeDateTime = ({ date }: { date: string }) => {
  const luxon = DateTime.fromJSDate(new Date(date));
  return (
    <span title={luxon.toLocaleString(DateTime.DATETIME_FULL)}>
      {luxon.toRelative()}
    </span>
  );
};
